<template>
  <div class="full-height" v-loading="isLoading">
    <div v-if="trailsinfoReqStatus === 'saved'">
      <table-toolbar
          :key="trailInfoCollection.key"
          v-if="visibleTrailColumns"
          :search-properties="visibleTrailColumns"
          :total-search-properties="trailColumns"
          :search-data="trailInfoCollection"
          :initial-tags="trailInfoCollection.searchTags"
          :reload-component="trailInfoCollection.reloadToolbar"
          :active-filter-data="activeFiltersData"
          :disable-search-box="disableSearchBox"
          @update-querydata="updateTableQueryData"
          @refresh-tabledata="refreshTableData"
          @update-columns-data="modifyColumnsData"
          @add-searchtags="addSearchTags"
          @deactivate-filter="deactivateFilter"
      >
        <div slot="left-toolbar-tools" class="filter-button-group">
          <span v-if="filterList.length">
            <div class="display-inline mr-18 relative-pos" v-for="(btn, index) in filterList" :key="index">
              <el-input
                  ref="customFilterInput"
                  class="filter-input"
                  v-if="btn.editFlag"
                  placeholder="+Name"
                  v-model="btn.name"
                  @change.native.stop="handleFilterNameChange(btn)"
                  @keyup.native.enter="handleFilterNameChange(btn)"
                  @blur="handleFilterNameChange(btn)"
              ></el-input>
              <el-button
                  v-else
                  size="small"
                  round
                  :class="{'active': btn.active}"
                  :id="btn.id"
                  @click="changeState(btn)"
              >
                {{ btn.name }}
                <el-tooltip class="item" effect="dark" content="Edit or Delete" placement="bottom">
                <span>
                  <i class="el-icon-edit el-icon--right" @click.stop="editFilter(btn)"></i>
                  <i class="el-icon-close el-icon--right" @click.stop="removeBtnFromList(btn, index)"></i>
                </span>
                </el-tooltip>
              </el-button>

              <span v-if="btn.errFlag" class="filter-name-validator">{{ filterErrMsg }}</span>
            </div>
          </span>
        </div>
        <div slot="search-actions" class="search-actions-flex">
          <el-button :disabled="disabledMitigateSelectedProgressions" @click="openMitigateDialog" size="medium"
          >Mitigate
          </el-button
          >
          <date-range-dropdown
              style="margin-left: 10px;"
              :disable-selection="isLoading"
              :store-pref-constant="daterangeUserPrefConstant"
              :date-range-val="trailProgressionDateRangeUserSetting"
          ></date-range-dropdown>
        </div>
        <div slot="local-helper" class="search-reset" v-if="isFingerprintUsed">
          <div class="grid-content helper-message">
            <p>Showing Progressions similar to {{ trailIdParam || fngerprintLabel }}</p>
            <el-button type="text" class="icon-text-button" @click="loadDocumentation('page-progressions')">
              <i class="material-icons c-icon"></i><span>Learn More</span>
            </el-button>
          </div>
        </div>
      </table-toolbar>
    </div>

    <multi-select-action-table-element
        v-if="trailsinfoReqStatus === 'saved'"
        ref="attacksTable"
        :columns="visibleTrailColumns"
        :table-data="trailInfoCollection"
        :height-offset="220"
        :actions="tableActions"
        @update-record-count="recordCountHandler"
        @table-selection-change="canMitigateSelectedProgressions"
    ></multi-select-action-table-element>

    <el-dialog :title="dialogueBoxTitle" :visible.sync="openAssignToDialogVisible">
      <el-form :model="selectedAttackTrail" v-if="usersListStatus == 'saved'">
        <div class="container">
          <div class="left" style="color:#454B60">
            <el-form-item label="Assignee" prop="email">
              <div style="margin-left: 96px;">
                <el-select
                    class="threat-assignee_dropdown"
                    @change="handleThreatHandoffAssigneeChange"
                    v-model="selectedAttackTrail.assignTo"
                    filterable
                    :placeholder="selectedAttackTrail.ownerId ? selectedAttackTrail.ownerId.fullname : 'Unassigned'"
                >
                  <user-button slot="prefix"
                               :classList="selectedAttackTrail.assignTo ? 'shamrock-200': '' "
                               :user="selectedAssignee"
                  ></user-button>
                  <el-option
                      v-for="item in usersList.models"
                      :key="item.email"
                      :label="`${item.firstname} ${item.lastname}`"
                      :value="item.email"
                  >
                  </el-option>
                </el-select>
              </div>
            </el-form-item>
            <el-form-item label="Status">
              <div style="margin-left:96px;">
                <el-select v-model="selectedTrailDetailsForJira.status" placeholder="Mitigation Not Started"
                           :disabled="!checked">
                  <el-option
                      v-for="item in jiraTicketStatusValues"
                      :key="item"
                      :label="item"
                      :value="item"
                  ></el-option>
                </el-select>
              </div>
            </el-form-item>
            <div style="display:inline">
              <span style="font-weight: 500;"> Comment </span>
              <el-input style="display:inline"
                        type="textarea"
                        rows="5"
                        v-model="selectedTrailDetailsForJira.comments"
              ></el-input>
            </div>
          </div>
          <div class="right">
            <div style="margin-left:39px;">
              <div style="display:flex;">
                <div>
                  <span>
                    <img style="width:42px; height:44.7px; margin-left:15px;" src="/static/images/logos/jira_image.svg"
                         alt="jira-icon"/>
                  </span>
                </div>
                <div style="margin-top:13px;">
              <span class="jira-text-integrate-with-jira">
                Create Jira ticket*
              </span>
                  <el-checkbox style="margin-left:10px;" v-model="checked"
                               :disabled="disableCheckboxOnPopUp"></el-checkbox>
                </div>
              </div>
            </div>
            <div class="the-title-of-threat-copy">
              <span>
                Threat Progression and description<br/>
                will appear as Jira issue.
              </span>
            </div>

            <div v-if="checked">
              <div class="jira-project-alignment">
                <el-form-item class="jira-project-selection" label="Project" prop="null">
                  <div style="margin-left:70px;">
                    <el-select
                        v-model="selectedTrailDetailsForJira.projectId"
                        filterable
                        :placeholder="jiraTicketDetails.project_key ? jiraTicketDetails.project_key : 'Select or add Jira project'"
                    >
                      <div v-if="jiraSettings.length === 0">
                        <el-option></el-option>
                        <router-link :to="{ name: 'integration-workflow', params: { integrationType: 'jira' } }"
                                     v-if="$allow('users', 'write')">
                          <a style="margin-left:21px;">+ Add new Jira project</a>
                        </router-link>
                      </div>
                      <div v-else>
                        <el-option
                            v-for="item in jiraSettings"
                            :key="item.id"
                            :label="item.project_id"
                            :value="item.project_id"
                        ></el-option>
                        <div style="margin-top:5px; margin-bottom:5px;" v-if="$allow('users', 'write')">
                          <el-divider direction="horizontal"></el-divider>
                        </div>
                        <router-link :to="{ name: 'integration-workflow', params: { integrationType: 'jira' } }"
                                     v-if="$allow('users', 'write')">
                          <a style="margin-left:21px;">+ Add new Jira project</a>
                        </router-link>
                      </div>
                    </el-select>
                  </div>
                </el-form-item>
              </div>
              <div class="jira-issue-alignment">
                <span class="jira-issue-selection">Issue</span>
                <el-radio v-model="radio" label="1">Task</el-radio>
                <el-radio v-model="radio" label="2">Story</el-radio>
                <el-radio v-model="radio" label="3">Bug</el-radio>
              </div>

              <div class="pointer-message-jira">
                * If you don’t see Assignee in Jira, your people <br/>
                list is not in sync. You’ll need to Assign the <br/>
                issue again inside Jira.
              </div>
            </div>
          </div>
        </div>
      </el-form>

      <div class="jira-button-alignment">
        <span slot="footer" class="dialog-footer">
          <el-button class="btn-cancel" @click="openAssignToDialogVisible = false">
            <span class="styl-cancel">Cancel</span>
          </el-button>
          <el-button class="btn-confirm" type="primary" @click="assignTrailWork(selectedAttackTrail)">
            <span class="styl-confirm">Confirm</span>
          </el-button>
        </span>
      </div>
    </el-dialog>

    <el-dialog title="Mitigate the Selected Progression" :visible.sync="openMitigateCurrentProgression">
      <el-form>
        <label>
          Are you sure you want to mitigate the following progression?
        </label>

        <h6><br/>Progressions selected:</h6>
        <span>{{ selectedAttackTrail.trailIdLabel }}</span>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button
            @click="
            openMitigateCurrentProgression = false
            disabledMitigateCurrentProgressions = false
          "
        >Cancel</el-button
        >
        <el-button type="primary" @click="mitigateCurrentProgression(selectedAttackTrail)">Confirm</el-button>
      </span>
    </el-dialog>

    <el-dialog style="text-align:center;" :visible.sync="openSuccessDialogue">
      <div>
        <div class="success-header">
          Success!
        </div>
        <div>
          <div style="jira-success-img-alignment">
            <img src="/static/images/jira-success-logo.svg">
          </div>
          <div v-if="checkForSuccessBox" style="height:200px; overflow-y:scroll">
            <p>Following threat Progressions may now be tracked in Jira.</p>
            <div>
              <li v-for="rec of mitigatedProgressionObject" :key="rec.trailID">
                Trail ID:
                <router-link :to="{ name: 'attack-track-details', params: { trailId: rec.trailID }}"
                >{{ rec.trailIDLabel }}
                </router-link>
                ,

                Ticket link: <span v-if="rec.ticketLink !== 'N/A'"><a :href="rec.ticketLink"
                                                                      target="_blank">click here</a></span><span v-else>N/A</span>
              </li>
            </div>
          </div>
          <div v-else>
            <p v-if="disableCheckboxOnPopUp">Jira ticket for {{ selectedAttackTrail.trailIdLabel }} has been
              updated.</p>
            <p v-else>Threat Progression {{ selectedAttackTrail.trailIdLabel }} may now be tracked in Jira.</p>
            <p>Your Jira ticket number is: <span style="font-weight:600">{{ jiraTicketDetails.ticket_key }} </span></p>
          </div>
        </div>

        <div class="goto-jira-btn" v-if="!checkForSuccessBox">
          <div>
            <a class="style-goto-jira"
               :href="jiraTicketDetails.jira_ticket_link"
               target="_blank"
            ><span>Go to Jira</span>
            </a>
          </div>
        </div>
      </div>
    </el-dialog>

    <el-dialog title="Mitigate the Selected Progression(s)" :visible.sync="openMitigateDialogVisible">
      <el-form>
        <label>
          Are you sure you want to mitigate the following progressions?
        </label>

        <h6><br/>Progressions selected:</h6>
        <span v-for="(progression, idx) in selectedProgressions" :key="idx">
          {{ progression.trailIdLabel }}
          <el-divider v-if="idx !== selectedProgressions.length - 1" direction="vertical"></el-divider>
        </span>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button
            @click="
            openMitigateDialogVisible = false
            disabledMitigateSelectedProgressions = false
          "
        >Cancel</el-button
        >
        <el-button type="primary" @click="mitigateSelectedProgressions">Confirm</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {mapGetters} from 'vuex'
import {
  TRAILSINFO_LIST_REQUEST,
  TRAILSINFO_LIST_SUCCESS,
  BULK_TRAIL_MITIGATION_REQ,
  TRAIL_ASSIGN_REQ,
  ACTIVE_PROGRESSION_VIEW_PREFERENCES_REQ,
  SAVE_ACTIVE_PROGRESSION_VIEW_PREFERENCES,
  TRAIL_MITIGATION_REQ
} from '@/store/modules/trails/trailsinfo.type'
import {PREFERENCE_STORE_REQ} from '@/store/modules/column-preference/column-preference.type'
import {USER_LIST_REQUEST, USER_LIST_SUCCESS} from '@/store/modules/user/user.type'
import {THREAT_PROGRESSION_DATE_RANGE_PREFERENCE} from '@/store/modules/user_pref/user-pref.type'
import {getUserFriendlyTrailLabel} from '@/utilities/trail.helper'
import {trailsMetaInfo} from '@/column-header/trail/trails-meta'
import {
  JIRA_CREATE_TICKET,
  JIRA_SETTING_REQUEST,
  JIRA_TICKET_FETCH_DETAILS,
  JIRA_ALL_TICKETS,
  JIRA_FETCH_TICKETS,
  JIRA_TICKET_STATUS_CHANGE
} from '@/store/modules/jira/jira-setting.type'

import PageHeaders from '@/components/layout/PageHeaders.vue'
import LineChartJs from '@/components/chart/LineChartJs.vue'
import DonutChartJs from '@/components/chart/DonutChartJs.vue'
import DonutholeChartLabelPlugin from '@/components/chart/plugins/donuthole-chart-label.plugin'
import MultiSelectActionTableElement from '@/components/table/MultiSelectActionTableElement.vue'
import TableToolbar from '@/components/table/TableToolbar.vue'
import UserButton from '@/components/button/UserButton.vue'
import DateRangeDropdown from '@/components/dropdown/DateRangeDropdown.vue'

import loadDocumentationMixin from '@/mixins/loadDocumentationMixin'
import customFilterMixin from '@/mixins/customFilterMixin'

export default {
  name: 'CyberAttacks',
  mixins: [loadDocumentationMixin, customFilterMixin],
  data() {
    return {
      tableName: "Progression",
      progressionColumnPrefs: {},
      daterangeUserPrefConstant: THREAT_PROGRESSION_DATE_RANGE_PREFERENCE,
      trailColumns: trailsMetaInfo.meta.columns,
      visibleTrailColumns: [],
      trailInfoCollection: {},
      selectedAttackTrail: {},
      selectedProgressions: [],
      isLoading: false,
      openAssignToDialogVisible: false,
      openMitigateDialogVisible: false,
      disabledMitigateSelectedProgressions: true,
      tableActions: [
        {
          name: 'handoff',
          icon: 'material-icons c-icon',
          iconSubject: 'person_add_alt_1',
          tooltip: 'Handoff Progression',
          rbac: {
            subject: 'cyber_attacks',
            operation: 'write'
          },
          actionHandler: selection => {
            this.handoffTrail(selection.row)
          }
        }
      ],
      checked: false,
      radio: '',
      selectedTrailDetailsForJira: {},
      jiraTicketStatusValues: ['Mitigation Not Started', 'Mitigation in Progress', 'Mitigated'],
      dialogueBoxTitle: '',
      tblId: 3,
      openSuccessDialogue: false, // for success screen after ticket creation.
      openMitigateCurrentProgression: false, // for Mitigate confirmation
      disabledMitigateCurrentProgressions: true,
      selectedAssignee: {},
      checkForSuccessBox: false,
      mitigatedProgressionObject: [],
      disableCheckboxOnPopUp: false
    }
  },
  methods: {
    getTrailListInfo(tableMetaData) {
      this.isLoading = true
      this.$store
        .dispatch(TRAILSINFO_LIST_REQUEST, {
          trailState: 'ACTIVE',
          dateRangeSel: this.trailProgressionDateRangeUserSetting
        })
        .then(
          trails => {
            this.isLoading = false
            this.trailInfoCollection = this.activeTrailsinfoRecords
            this.$store.dispatch(TRAILSINFO_LIST_SUCCESS)
            this.setTableMetaData(tableMetaData)
            this.fetchJiraTickets();
          },
          errMsg => {
            this.isLoading = false
            console.log(errMsg)
          }
        )
    },
    gotoDetails(trailId) {
      this.$router.push({
        name: 'attack-track-details',
        params: {trailId: trailId}
      })
    },
    fetchJiraTickets() {
      this.$store.dispatch(JIRA_ALL_TICKETS).then(() => {
        let allTicketIds = []
        for (let i of this.jiraAllTickets) {
          allTicketIds.push(i.trail_id);
        }
        for (let entry of this.activeTrailsinfoRecords.models) {
          if (allTicketIds.includes(entry.id)) {
            let currentTrail = this.jiraAllTickets.filter(rec => rec.trail_id === entry.id)
            entry.jiraTicketLink = currentTrail[0].jira_ticket_link
            entry.jiraTicketId = currentTrail[0].ticket_key
            entry.stringify += entry.jiraTicketId.toLowerCase()
          } else {
            entry.jiraTicketLink = ""
            entry.jiraTicketId = "N/A"
          }
        }
      })
    },
    handoffTrail(trail) {
      this.checkForSuccessBox = false
      this.checked = false // This is for IntegrateWithJira checkbox handling.
      this.selectedAssignee = _.cloneDeep(trail.ownerId)
      this.selectedAttackTrail = trail
      this.$store.dispatch(JIRA_TICKET_FETCH_DETAILS, {
        selectedTrail: this.selectedAttackTrail.trailIdHash
      }).then(_ => {
        if (this.jiraTicketDetails.issue_type === 'Task') {
          this.radio = "1"
          this.checked = true
          this.disableCheckboxOnPopUp = true
        } else if (this.jiraTicketDetails.issue_type === 'Story') {
          this.radio = "2"
          this.checked = true
          this.disableCheckboxOnPopUp = true
        } else if (this.jiraTicketDetails.issue_type === 'Bug') {
          this.radio = "3"
          this.checked = true
          this.disableCheckboxOnPopUp = true
        } else {
          this.radio = ''
          this.checked = false
          this.disableCheckboxOnPopUp = false
        }

        // This section is responsible for Jira Ticket Status and Confluera progression's sync.
        if (this.jiraTicketDetails.status === 'Done') {
          this.jiraTicketDetails.status = 'Mitigated'
          this.selectedTrailDetailsForJira = this.jiraTicketDetails
        } else if (this.jiraTicketDetails.status === 'To Do') {
          this.jiraTicketDetails.status = 'Mitigation Not Started'
          this.selectedTrailDetailsForJira = this.jiraTicketDetails
        } else if (this.jiraTicketDetails.status === 'In Progress') {
          this.jiraTicketDetails.status = 'Mitigation in Progress'
          this.selectedTrailDetailsForJira = this.jiraTicketDetails
        } else {
          this.selectedTrailDetailsForJira = {}
        }
      })
      this.dialogueBoxTitle = `Threat Progression ${this.selectedAttackTrail.trailIdLabel}`
      this.openAssignToDialogVisible = true
    },
    assignTrailWork(selectedTrail) {
      // Added selectedTrail.ownerId.email for syncing Assignee.
      selectedTrail.comments = this.selectedTrailDetailsForJira.comments
      if (selectedTrail.assignTo || selectedTrail.ownerId.email) {
        this.$store
          .dispatch(TRAIL_ASSIGN_REQ, {
            assignFrom: this.userProfile.email,
            assignTo: selectedTrail.assignTo ? selectedTrail.assignTo : selectedTrail.ownerId.email,
            trailId: selectedTrail.trailIdHash,
            comments: selectedTrail.comments
          })
          .then(
            () => {
              let assignedToUser = _.find(this.usersList.models, {
                email: selectedTrail.assignTo ? selectedTrail.assignTo : selectedTrail.ownerId.email
              })
              this.selectedAttackTrail.setOwnerId(assignedToUser)
              this.openAssignToDialogVisible = false

              if (this.checked) {
                // This section is responsible for Jira Ticket Status and Confluera progression's sync.
                if (this.selectedTrailDetailsForJira.status === 'Mitigation Not Started' || typeof this.selectedTrailDetailsForJira.status === 'undefined') {
                  this.selectedTrailDetailsForJira.status = 'To Do'
                } else if (this.selectedTrailDetailsForJira.status === 'Mitigated') {
                  this.selectedTrailDetailsForJira.status = 'Done'
                } else {
                  this.selectedTrailDetailsForJira.status = 'In Progress'
                }

                let payload = {
                  action_name: 'Progression_Assignment',
                  trail_id: selectedTrail.trailIdHash,
                  trail_id_label: selectedTrail.trailIdLabel,
                  target_user: assignedToUser.fullname,
                  project_id: this.selectedTrailDetailsForJira.projectId ? this.selectedTrailDetailsForJira.projectId : this.jiraTicketDetails.project_key,
                  status: this.selectedTrailDetailsForJira.status
                    ? this.selectedTrailDetailsForJira.status
                    : this.jiraTicketDetails.status,
                  type_of_ticket: this.radio,
                  description: selectedTrail.comments
                    ? selectedTrail.comments
                    : (this.jiraTicketDetails.ticket_description
                      ? this.jiraTicketDetails.ticket_description
                      : selectedTrail.trailIdLabel
                    ),
                  assignee_email: selectedTrail.assignTo ? selectedTrail.assignTo : selectedTrail.ownerId.email
                }
                if (typeof this.jiraTicketDetails !== 'undefined') {
                  if (payload.status === "Done") {
                    const comment = payload.description
                    // payload.description = 'Some Random text'
                    this.$store.dispatch(JIRA_CREATE_TICKET, payload).then(_ => {
                      let payloadForComment = {
                        trail_id: selectedTrail.trailIdHash,
                        status_type: "In Progress",
                        comment_for_ticket: comment
                      }
                      this.$store.dispatch(JIRA_TICKET_STATUS_CHANGE, payloadForComment).then(_ => {
                        this.fetchJiraTickets();
                        this.checkForSelectedMitigation()
                        this.selectedTrailDetailsForJira.status = ''
                      });
                    })
                  } else {
                    this.$store.dispatch(JIRA_CREATE_TICKET, payload).then(() => {
                      const comment = payload.description
                      // payload.description = 'Some Random text'
                      const payloadForComment = {
                        trail_id: selectedTrail.trailIdHash,
                        status_type: payload.status,
                        comment_for_ticket: comment
                      }
                      if (typeof selectedTrail.comments === 'undefined') {
                        this.fetchJiraTickets();
                        this.selectedTrailDetailsForJira.status = ''
                        this.$store.dispatch(JIRA_TICKET_FETCH_DETAILS, {
                          selectedTrail: this.selectedAttackTrail.trailIdHash
                        }).then(_ => {
                          this.openSuccessDialogue = true
                        })
                      } else {
                        this.$store.dispatch(JIRA_TICKET_STATUS_CHANGE, payloadForComment).then(_ => {
                          this.fetchJiraTickets();
                          this.selectedTrailDetailsForJira.status = ''
                          this.$store.dispatch(JIRA_TICKET_FETCH_DETAILS, {
                            selectedTrail: this.selectedAttackTrail.trailIdHash
                          }).then(_ => {
                            this.openSuccessDialogue = true
                          })
                        });
                      }
                    })
                    this.selectedTrailDetailsForJira.status = ''
                  }
                } else {
                  if (payload.status === "Done") {
                    this.$store.dispatch(JIRA_CREATE_TICKET, payload).then(_ => {
                      this.fetchJiraTickets();
                      this.checkForSelectedMitigation()
                      this.selectedTrailDetailsForJira.status = ''
                    })
                  } else {
                    this.$store.dispatch(JIRA_CREATE_TICKET, payload).then(() => {
                      this.fetchJiraTickets();
                      this.$store.dispatch(JIRA_TICKET_FETCH_DETAILS, {
                        selectedTrail: this.selectedAttackTrail.trailIdHash
                      }).then(_ => {
                        this.openSuccessDialogue = true
                      })
                    })
                    this.selectedTrailDetailsForJira.status = ''
                  }
                }
              } else {
                if (this.selectedTrailDetailsForJira.status === 'Done') {
                  this.checkForSelectedMitigation()
                }
              }
              this.$message({
                type: 'success',
                message: `Threat Progression ${_.has(selectedTrail, 'trailIdLabel') &&
                    selectedTrail.trailIdLabel ? selectedTrail.trailIdLabel : selectedTrail.trailIdHash}
                  is now assigned to ${selectedTrail.assignTo ? selectedTrail.assignTo : selectedTrail.ownerId.email}.`
              })
            },
            errMsg => {
              // keep open & show error
              this.$message({
                type: 'error',
                message: errMsg.data.message || `Something went wrong.`
              })
              this.openAssignToDialogVisible = true
            }
          )
      } else {
        this.$message({
          type: 'error',
          message: `Something went wrong. (select assignee and status)`
        })
      }
    },
    assignToSelf(trail) {
      // this vue module instance
      let vm = this
      this.$confirm(`This will assign ${trail.trailIdHash} to yourself. Continue?`, 'Assign to Self', {
        confirmButtonText: 'OK',
        cancelButtonText: 'Cancel',
        callback: function (action) {
          if (action === 'confirm') {
            vm.$store
              .dispatch(TRAIL_ASSIGN_REQ, {
                assignFrom: vm.userProfile.email,
                assignTo: vm.userProfile.email,
                trailId: trail.trailIdHash
              })
              .then(
                () => {
                  vm.$message({
                    type: 'success',
                    message: `Threat Progression ${trail.trailIdHash} is now assigned to you.`
                  })
                },
                errMsg => {
                }
              )
          } else if (action === 'cancel') {
            vm.$message({
              type: 'info',
              message: `Assignment canceled`
            })
          }
        }
      })
    },
    updateTableQueryData() {
      if (this.$refs.attacksTable) {
        if (_.isEmpty(this.trailInfoCollection.searchTags)) {
          this.$router.replace({
            query: {
              date_range: this.trailProgressionDateRangeUserSetting
            }
          })
        }
        this.$refs.attacksTable.updateTableData()
      }
    },
    recordCountHandler() {
      // key is used to re-render TableToolbar component
      // on page change to update 'queryCountText'
      this.trailInfoCollection.key = !this.trailInfoCollection.key
      this.trailInfoCollection.reloadToolbar = false
    },
    modifyColumnsData(selectedColumns) {
      this.progressionColumnPrefs.userId = this.userProfile.id;
      this.progressionColumnPrefs.tblName = this.tableName;
      this.progressionColumnPrefs.preferedCols = selectedColumns.length === 0 ? NaN : selectedColumns;
      this.progressionColumnPrefs.tblId = 3;

      this.visibleTrailColumns = this.trailInfoCollection.updateVisibleColumns(this.trailColumns, selectedColumns)

      this.$store.dispatch(SAVE_ACTIVE_PROGRESSION_VIEW_PREFERENCES, this.progressionColumnPrefs).then(
        data => {
          // store preferences in vuex
          this.progressionColumnPrefs.preferedCols = this.visibleTrailColumns;
          this.$store.dispatch(PREFERENCE_STORE_REQ, this.progressionColumnPrefs)
            .then(_ => {
              this.$refs.attacksTable.refreshLayout()
            })
        })
    },
    callApi(tableMetaData) {
      if (this.usersListStatus !== 'saved') {
        this.$store.dispatch(USER_LIST_REQUEST).then(data => {
          this.$store.dispatch(USER_LIST_SUCCESS)
        })
      }
      this.getTrailListInfo(tableMetaData)
    },
    setTableMetaData(tableMetaData) {
      this.trailInfoCollection.searchTags = tableMetaData.searchTags
      this.trailInfoCollection.currentPage = tableMetaData.activePage
    },
    refreshTableData(tableMetaData) {
      this.callApi(tableMetaData)
    },
    loadProgressionColumnPreferences() {
      // check if already present in store
      if (_.has(this.userPref, this.userProfile.id) && _.has(this.userPref[this.userProfile.id], this.tableName)) {
        //  read values from store
        this.visibleTrailColumns = this.userPref[this.userProfile.id][this.tableName]
        // this.updateStoreWithPrefs()
      } else {
        // fetch from database
        this.$store.dispatch(ACTIVE_PROGRESSION_VIEW_PREFERENCES_REQ, this.userProfile.id)
          .then(data => {
            this.visibleTrailColumns = this.trailColumns.filter(col => {
              return this.activeProgressionPreferences.includes(col.label)
            })
            this.updateStoreWithPrefs()
          })
      }
    },
    updateStoreWithPrefs() {
      this.progressionColumnPrefs = {
        userId: this.userProfile.id,
        tblName: this.tableName,
        preferedCols: this.visibleTrailColumns
      }

      this.$store.dispatch(PREFERENCE_STORE_REQ, this.progressionColumnPrefs);
    },
    canMitigateSelectedProgressions() {
      if (this.$refs.attacksTable.rowsSelected.length > 0) {
        this.disabledMitigateSelectedProgressions = false
      } else {
        this.disabledMitigateSelectedProgressions = true
      }
    },
    openMitigateDialog() {
      this.selectedProgressions = this.$refs.attacksTable.rowsSelected
      this.openMitigateDialogVisible = true
    },
    mitigateSelectedProgressions() {
      this.checkForSuccessBox = false
      this.disabledMitigateSelectedProgressions = true
      let email = this.userProfile.email
      let trailIds = []

      let trailIdLabels = []

      this.$refs.attacksTable.rowsSelected.forEach(trail => {
        trailIds.push(trail.id)
        trailIdLabels.push(trail.trailIdLabel)
      })
      this.$store
        .dispatch(BULK_TRAIL_MITIGATION_REQ, {
          assignFrom: email,
          assignTo: email,
          trails: trailIds
        })
        .then(() => {
          this.disabledMitigateSelectedProgressions = false
          this.openMitigateDialogVisible = false
          this.$store.dispatch(JIRA_FETCH_TICKETS).then(_ => {
            for (let trail of trailIds) {
              if (this.fetchTickets.includes(trail)) {
                let payload = {
                  trail_id: trail,
                  status_type: "Mitigated",
                  comment_for_ticket: 'Trail has been mitigated'
                }
                this.$store.dispatch(JIRA_TICKET_STATUS_CHANGE, payload);
              }
            }

            this.mitigatedProgressionObject = []
            let temp = []
            for (let id of trailIds) {
              if (this.fetchTickets.includes(id)) {
                for (let ticket of this.jiraAllTickets) {
                  if (ticket.trail_id === id) {
                    temp.push(ticket.jira_ticket_link)
                    break;
                  }
                }
              } else {
                temp.push('N/A') // Storing N/A inside array if ticket being not created
              }
            }
            for (let cnt = 0; cnt < trailIds.length; cnt++) {
              let obj = {
                'trailID': trailIds[cnt],
                'ticketLink': temp[cnt],
                'trailIDLabel': trailIdLabels[cnt]
              }
              this.mitigatedProgressionObject.push(obj);
            }
            this.checkForSuccessBox = true // For checking whether a single progression or list of progression selected
            this.openSuccessDialogue = true
          })
          this.refreshTableData({
            activePage: 1,
            searchTags: this.trailInfoCollection.searchTags
          })
        })
    },
    gotoTrails() {
      this.$router.push({name: 'active-cyber-attacks'})
      this.openSuccessDialogue = false
    },
    checkForSelectedMitigation(currentSelectedTrail) {
      this.disabledMitigateCurrentProgressions = true
      this.openMitigateCurrentProgression = true
    },
    mitigateCurrentProgression(currentSelectedTrail) {
      this.$store
        .dispatch(TRAIL_MITIGATION_REQ, {
          assignFrom: this.userProfile.email,
          assignTo: this.userProfile.email,
          trailId: currentSelectedTrail.trailIdHash
        })
        .then(
          () => {
            this.disabledMitigateCurrentProgressions = false
            this.openMitigateCurrentProgression = false
            this.$store.dispatch(JIRA_FETCH_TICKETS).then(_ => {
              if (this.fetchTickets.includes(currentSelectedTrail.trailIdHash)) {
                let payload = {
                  trail_id: currentSelectedTrail.trailIdHash,
                  status_type: "Mitigated",
                  comment_for_ticket: 'Trail has been mitigated'
                }
                this.$store.dispatch(JIRA_TICKET_STATUS_CHANGE, payload).then(_ => {
                  this.$store.dispatch(JIRA_TICKET_FETCH_DETAILS, {
                    selectedTrail: currentSelectedTrail.trailIdHash
                  }).then(_ => {
                    this.openSuccessDialogue = true
                  })
                });
              }
            })
          },
          errMsg => {
            this.openMitigateCurrentProgression = false
            this.disabledMitigateCurrentProgressions = false
          }
        )
    },
    handleThreatHandoffAssigneeChange() {
      const selectedUser = this.usersList.models.filter(user => user.email === this.selectedAttackTrail.assignTo)
      this.selectedAssignee = _.cloneDeep(selectedUser[0])
    }
  },
  created() {
    let tableMetaData = {
      activePage: 1,
      searchTags: []
    }
    if (!this.$_.isEmpty(this.$route.query.date_range)) {
      this.$store.dispatch(this.daterangeUserPrefConstant, this.$route.query.date_range)
    }
    if (!this.$_.isEmpty(this.$route.query.fingerprint)) {
      tableMetaData.searchTags.push(this.$route.query.fingerprint)
    }
    this.callApi(tableMetaData)

    this.loadProgressionColumnPreferences();
    this.$store.dispatch(JIRA_SETTING_REQUEST);
  },
  watch: {
    trailProgressionDateRangeUserSetting: {
      handler: function (newDateRange, oldDateRange) {
        if (newDateRange !== oldDateRange) {
          this.refreshTableData({
            activePage: 1,
            searchTags: this.trailInfoCollection.searchTags
          })
        }
      }
    }
  },
  computed: {
    ...mapGetters([
      'trailsinfoReqStatus',
      'activeTrailsinfoRecords',
      'userProfile',
      'usersList',
      'usersListStatus',
      'trailsAssignmentStatus',
      'trailProgressionDateRangeUserSetting',
      'activeProgressionPreferences',
      'userProfile',
      'userPref',
      'projectIds',
      'jiraSettings',
      'jiraTicketDetails',
      'jiraAllTickets',
      'fetchTickets'
    ]),
    fngerprintLabel() {
      return this.$route.query.fingerprint
    },
    isFingerprintUsed() {
      return !_.isEmpty(this.$route.query.fingerprint)
    },
    trailIdParam() {
      if (this.$route.params.trailId) {
        return this.$route.params.trailId
      }
      if (this.$route.params.trailHashId) {
        return getUserFriendlyTrailLabel(this.$route.params.trailHashId)
      }
      return undefined
    },
    lineChartOptions() {
      return {
        layout: {
          padding: {
            left: 10,
            right: 10
          }
        },
        tooltips: {
          enabled: true
        },
        elements: {
          point: {
            pointStyle: 'line'
          },
          line: {
            fill: true,
            backgroundColor: 'rgb(242, 248, 255)',
            borderColor: 'rgb(0, 112, 249)'
          }
        }
      }
    },
    donutLabelPlugin() {
      return DonutholeChartLabelPlugin
    },
    donutOptions() {
      return {
        cutoutPercentage: 80,
        rotation: 0.8 * Math.PI,
        circumference: 1.4 * Math.PI,
        plugins: {
          'donuthole-chart-label-plugin': {
            style: {
              circleFillColor: '#eff0f2',
              textfillColor: '#2e3344'
            }
          }
        }
      }
    }
  },
  components: {
    PageHeaders,
    LineChartJs,
    DonutChartJs,
    MultiSelectActionTableElement,
    TableToolbar,
    UserButton,
    DateRangeDropdown
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@import 'assets/styles/_variables.css';

.el-col {
  padding-bottom: 8px;
}

.el-card {
  padding-top: 5px;
}

.trails-info {
  max-width: 65%;

  > span {
    display: block;
    padding: 2px;
  }
}

.title {
  font-size: 0.9em;
  font-weight: bold;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.info {
  font-size: 0.8em;
}

.trail-icon {
  transform: rotate(90deg);
}

.material-icons {
  font-size: 2em;
  margin-left: 10px;
}

.el-dropdown-menu.el-popper {
  .material-icons {
    font-size: 1em;
    margin-left: 0px;
  }
}

.el-card__body {
  padding: none !important;

  > div {
    margin: 5px;
  }
}

.circle {
  width: 24px;
  height: 24px;
  display: table-cell;
  border-radius: 50%;
  font-size: 15px;
  color: #fff;
  line-height: 24px;
  text-align: center;
  background: var(--primary-blue-400);
}

.el-button--mini {
  padding: 5px;
}

.view-mode {
  height: 40px;
  width: 100px;
  vertical-align: middle;
  line-height: 40px;

  .el-select:before {
    content: '\e896';
    font-family: 'Material Icons';
    font-size: 20px;
    margin-right: 16px;
    color: var(--gray-500);
    left: 50px;
    position: relative;
  }

  >>> .el-select {
    height: inherit;

    .el-input.el-input--suffix {
      visibility: hidden;
      top: -45px;
    }
  }
}

/* .search-box .el-button {
  padding: 9px;
  border-radius: 0;
  border: 1px solid var(--border-color);
} */

.bottom {
  border-top: 1px solid #f0f0f0;
}

.clearfix:before,
.clearfix:after {
  display: table;
  content: '';
}

.clearfix:after {
  clear: both;
}

.display-none {
  display: none;
}

.search-reset {
  line-height: 36px;

  p {
    display: inline;
  }

  .icon-text-button {
    background: var(--denim-500);
    padding: 5px 10px;
    vertical-align: middle;

    span {
      color: white;
    }

    .c-icon {
      margin-right: 0px !important;
    }
  }

  .helper-message {
    background: var(--denim-50);
    padding: 20px;
  }
}

.el-form-item ::before, .el-form-item ::after {
  color: #454B60;

}

.el-form-item {
  color: #454B60;
}

.el-select {
  height: 41px;
  width: 279px;
  border-radius: 2px;
  border: 1px solid #A1A8AE;
  background-color: #FFFFFF;
}

>>> .el-input--suffix .el-input__inner {
  border: none
}

.threat-assignee_dropdown {
  >>> .el-input--prefix .el-input__prefix {
    left: 13px;
  }

  >>> .el-input--suffix .el-input__inner {
    border: none;
    padding-left: 58px;
  }
}

>>> .avatar-circle, .avatar-circle:hover {
  background: #77DAB4 !important;
}

.el-radio {
  color: #454B60
}


.the-title-of-threat-copy {
  height: 48px;
  width: 298px;
  color: #454B60;
  font-size: 15px;
  letter-spacing: 0;
  line-height: 24px;
  margin-top: 12px;
  margin-left: 115px;
}

.pointer-message-jira {
  height: 72px;
  width: 316px;
  color: #454B60;
  font-size: 15px;
  letter-spacing: 0;
  line-height: 24px;
  margin-top: 26px;
  margin-left: 115px;
}

.jira-project-selection {
  width: 400px;
  margin-left: -15px;
}

.container {
  display: flex;
  flex-direction: row;
}

.left {
  height: 400px;
  display: block;
  width: 48%;
}

.right {
  height: 370px;
  display: block;
  width: 50%;
}

.btn-confirm {
  height: 36px;
  width: 132px;
  border-radius: 4px;
  background-color: #1890FA;
  justify-content: center;
  align-items: center;
  padding: 0px;
}

.btn-cancel {
  box-sizing: border-box;
  height: 36px;
  width: 132px;
  border: 1px solid #A1A8AE;
  border-radius: 4px;
  justify-content: center;
  align-items: center;
  padding: 0px;
}

.styl-cancel {
  height: 20px;
  width: 68px;
  color: #454B60;
  font-size: 14px;
  font-weight: 400;
  letter-spacing: 0.1px;
  line-height: 20px;
  text-align: center;
}

.styl-confirm {
  height: 20px;
  width: 68px;
  color: #FFFFFF;
  font-size: 14px;
  font-weight: 600;
  letter-spacing: 0.1px;
  line-height: 20px;
  text-align: center;
}

>>> .el-form-item__label {
  color: #454B60;
  font-weight: 500;
}

>>> .el-textarea__inner {
  width: 279px;
  margin-left: 98px;
  margin-top: -15px;
  /* border: 1px solid #454B60; */
  border: 1px solid #A1A8AE;
}

>>> .el-dialog__title {
  height: 35px;
  width: 428px;
  color: #454B60;
  font-size: 30px;
  font-weight: 300;
  letter-spacing: 0;
  line-height: 35px;
}

>>> .el-dialog__body {
  padding-left: 63px;
  padding-right: 73px;
}

>>> .el-dialog__header {
  padding: 36px 28px 10px;
  margin-left: 30px;
}

>>> .el-dialog {
  border-radius: 7px;
  width: 965px;
  height: 591px;
}

>>> .el-radio {
  width: 49px;
}

.jira-text-integrate-with-jira {
  /* color:#454B60;
  font-weight: 500; */
  height: 24px;
  width: 137px;
  color: #454B60;
  /* font-family: Montserrat; */
  font-size: 15px;
  font-weight: 600;
  letter-spacing: 0;
  line-height: 24px;
  margin-left: 20px;
}

.jira-issue-selection {
  margin-right: 36px;
  color: #454B60;
  font-weight: 500;
}

.jira-button-alignment {
  margin-top: -28px;
  float: right;
}

.jira-project-alignment {
  margin-top: 30px;
  margin-left: 56px;
}

.jira-issue-alignment {
  margin-left: 43px;
  margin-top: 25px;
}

>>> .el-input__inner::-webkit-input-placeholder,
>>> .el-input__inner {
  color: #454B60;
}

>>> .el-input__inner::placeholder { /* Chrome, Firefox, Opera, Safari 10.1+ */
  color: #454B60;
  opacity: 1; /* Firefox */
}

>>> .el-textarea__inner::-webkit-input-placeholder,
>>> .el-textarea__inner {
  color: #454B60;
  /* border:1px solid #A1A8AE; */
}

>>> .el-input__inner:-ms-input-placeholder,
>>> .el-input__inner::-ms-input-placeholder {
  color: #454B60;
}

.filter-button-group {
  .el-button {
    background-color: white;
    color: var(--gray-800);
    margin-bottom: 25px;

    &.active {
      background-color: var(--denim-600);
      color: white;
    }
  }


  >>> .el-input {
    input {
      border-radius: 20px;
      width: 102px;
      height: 37px;
    }
  }

}

.filter-input {
  display: table-cell;
}

>>> .search-box-container {
  position: relative;
  right: 7%;
}

.layout-container .container .page-table {
  height: 78%;
}

.filter-name-validator {
  position: absolute;
  top: 34px;
  left: 3px;
  color: red;
  width: 110px;
}

.relative-pos {
  position: relative;
}

.success-header {
  font-size: 30px;
  color: #297FCA;
  font-weight: 300;
  margin-top: -15px;
  margin-bottom: 65px;
}

.goto-jira-btn {
  height: 36px;
  width: 139px;
  border-radius: 4px;
  background-color: #1A90FA;
  /* align-items: center; */
  margin-left: 42%;
  margin-top: 45px;
}

.style-goto-jira {
  height: 30px;
  width: 139px;
  color: #FFFFFF;
  font-size: 14px;
  font-weight: 600;
  letter-spacing: 0.1px;
  position: absolute;
  margin-top: 7px;
  margin-left: -69px;
  text-decoration: none;
}

.jira-success-img-alignment {
  margin-top: 37px;
  margin-bottom: 28px;
}

.back-to-threat {
  margin-top: 20px;
  font-weight: 600;
}

.search-actions-flex {
  display: flex;
  flex-wrap: nowrap;
  width: max-content;
}

>>> .el-divider--horizontal {
  margin-top: 10px;
  margin-bottom: 10px;
}

>>> .vue-tags-search-box {
  width: 320px;
}

>>> .search-box-container {
  position: relative;
  right: 300px;
}
</style>



// WEBPACK FOOTER //
// src/views/monitor/cyber_attacks/CyberAttacks.vue